import axios from 'axios';
import { browserHistory } from 'react-router';
import { API_URL } from '../config';

const httpClient = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  withCredentials: true,
});

// Setup axios
httpClient.defaults.withCredentials = true;
httpClient.interceptors.response.use(null, (err) => {
  if (err.response && err.response.status && err.response.status === 401) {
    browserHistory.push('/login');
  }

  return Promise.reject(err);
});

export default httpClient;



// WEBPACK FOOTER //
// ./src/utils/httpClient.js